import { Icon } from '@chakra-ui/react';

export const PlayBack = (props: any) => (
  <Icon aria-label="playback icon" viewBox="0 0 14 14" {...props}>
    <path d="M7 4l5 3-5 3V7.6L3 10V4l4 2.4z" fill="currentColor" />
  </Icon>
);
